<template>
    <!-- <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', textColor]" /> -->
    <feather-icon
      icon="FileIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="exportRecord()"
    />
</template>

<script>
export default {
  name: 'CellRendererVerified',
  methods: {
    exportRecord() {
      let vm = this;
      this.$vs.loading();
      this.$store
        .dispatch("clientManagement/getGoogleSheetRows", this.params.clientId)
        .then((row) => {
          this.$vs.loading.close();
          if (row.primaryData && row.primaryData.length) {
            var datarow = [];
            var AttendeeData = [];
            for(let [index, item] of row.primaryData.entries()){
              AttendeeData.push(item);
            }             
            //AttendeeData.push(datarow);
            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = "InterestedRegisteredUsers" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
        })
        .catch(err => {
          this.$vs.loading.close();
        });
    },
  }
}
</script>
